import React from 'react';
import { Controller, Menu } from '@tencent/workbench';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import { MENU_CONFIGS } from './config';
import { FileInfoPanel } from '@framework/workbench/ui/file-info-panel/components/file-info-panel';
import { FileInfoPanelFeature } from '@framework/workbench/ui/file-info-panel/file-info-panel-feature';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

@Controller({ menuItems: MENU_CONFIGS })
export class FileInfoController {
    constructor(private readonly fileInfoPanelFeature: FileInfoPanelFeature) {}

    @Menu(MenuKey.FILE_INFO, 'onClick')
    public showDocInfoPanel() {
        this.fileInfoPanelFeature.show();
    }

    @Menu(MenuKey.FILE_INFO, 'shouldHide')
    public hideLocalSave(): boolean {
        // 母版编辑下隐藏文件信息
        const isMasterEditType = !!(AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.masterLayoutEditService.isMasterEditType;
        return !DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.fileInfo) || isMasterEditType;
    }
}
